import React from 'react';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import PlanDetails from 'components/settings/PaymentPlanDetails';


import { appTitle, titleSeparator } from 'config/helmetSettings';

const PaymentPlanDetails = () => (
  <Layout variant="settings">
    <Helmet>
      <title>
        {appTitle} {titleSeparator} Payment Plan Details
      </title>
    </Helmet>
    <PlanDetails />
  </Layout>
);

export default PaymentPlanDetails;



// WEBPACK FOOTER //
// ./src/pages/settings/PaymentPlanDetails.js